import {
  PROPOSALS_REQUEST, PROPOSALS_SUCCESS, PROPOSALS_FAILURE,
  PROPOSAL_CREATE_REQUEST, PROPOSAL_CREATE_SUCCESS, PROPOSAL_CREATE_FAILURE,
  PROPOSAL_UPDATE_REQUEST, PROPOSAL_UPDATE_SUCCESS, PROPOSAL_UPDATE_FAILURE,
  PROPOSAL_DELETE_REQUEST, PROPOSAL_DELETE_SUCCESS, PROPOSAL_DELETE_FAILURE,
  PROPOSALS_RESET,
} from '../actions/proposals'

const INITIAL_STATE = {
  proposals: null,
  loading: false,
  error: null,
  needsRefresh: false,
  lastSaved: null,
}

const proposalsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROPOSALS_REQUEST:
    case PROPOSAL_CREATE_REQUEST:
    case PROPOSAL_UPDATE_REQUEST:
    case PROPOSAL_DELETE_REQUEST:
      return { ...state, error: null, loading: true }

    case PROPOSALS_SUCCESS:
      return { ...state, proposals: action.response, needsRefresh: false, loading: false }

    case PROPOSAL_CREATE_SUCCESS:
      return { ...state, lastSaved: action.response, needsRefresh: true, loading: false }

    case PROPOSAL_UPDATE_SUCCESS:
      return { ...state, lastSaved: action.response, needsRefresh: true, loading: false }

    case PROPOSAL_DELETE_SUCCESS:
      return { ...state, needsRefresh: true, loading: false }

    case PROPOSALS_FAILURE:
    case PROPOSAL_CREATE_FAILURE:
    case PROPOSAL_UPDATE_FAILURE:
    case PROPOSAL_DELETE_FAILURE:
      return { ...state, error: action.error, loading: false }

    case PROPOSALS_RESET:
      return { ...state, error: null, loading: false, lastSaved: null }

    default:
      return state
  }
}

export default proposalsReducer
